exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-group[data-v-9263f090]{margin:.5rem .5rem 0;max-height:6rem;overflow:scroll}.checkbox-group .van-checkbox[data-v-9263f090]{margin-bottom:.3rem}", ""]);

// exports
